"use strict";

angular.module("core")
.component("departmentSelector", {
    templateUrl: require("./department-selector.component.html"),
    controller: DepartmentSelectorController,
    controllerAs: "departmentSelectorCtrl",
    bindings: {
        model: "=",
        form: "=",
        isFormSubmitted: "<",
        default: "<?",
        required: "<?"
    }
});

function DepartmentSelectorController($scope, DepartmentService) {
    var _this = this;

    this.$onInit = function() {
        DepartmentService.query().$promise.then(function onSuccess(data) {
            if ((!_this.model || !_this.model.length) && _this.default) {
                _this.model = angular.copy(_this.default);
            }

            // Used to manage required error when submitting the form
            _this.selectedDepartments = _this.model.toString();

            _this.departments = data;
        });
    };

    this.updateSelected = function(departmentId) {
        if (!this.model) {
            return;
        }

        var index = this.model.indexOf(departmentId);
        if (index !== -1) {
            this.model.splice(index, 1);
        } else {
            this.model.push(departmentId);
        }
        this.selectedDepartments = this.model.toString();
    };

    this.isSelected = function(departmentId) {
        if (!this.model) {
            return false;
        }
        return this.model.indexOf(departmentId) !== -1;
    };

    this.isDepartmentsDifferent = function() {
        if (!this.model || !this.default) {
            return false;
        }
        this.default.sort();
        this.model.sort();
        return this.model.toString() !== this.default.toString();
    };
}



//////////////////
// WEBPACK FOOTER
// ./core/department-selector/department-selector.component.js
// module id = 620
// module chunks = 0